import { LicenseValidityChooserDateConstraints } from './license-validity-chooser-date-constraints';
import { LicenseValidityChooserDurationConstraints } from './license-validity-chooser-duration-constraints';

export interface LicenseValidityChooser<T = Date> {
  dateConstraints: LicenseValidityChooserDateConstraints<T> | null;
  durationConstraints: LicenseValidityChooserDurationConstraints<T> | null;
}
